/**
 * Stable CSS class names for E2E — Expense note list, filter drawer, PDF preview.
 */
export const EXPNOTE = {
    page: 'expense-note-page',
    toolbarRow: 'expense-note-page__toolbar-row',
    gridSection: 'expense-note-page__grid-section',
    inputButtonDetailedSearch: 'expense-note-page-input--button-detailed-search',
} as const;

export const EXPNOTEFILTER = {
    root: 'expense-note-filter-drawer',
    headerRow: 'expense-note-filter-drawer__header-row',
    title: 'expense-note-filter-drawer__title',
    closeTrigger: 'expense-note-filter-drawer-input--icon-close',
    dateRangeWrap: 'expense-note-filter-drawer__date-range-wrap',
    inputTextfieldOrderNo: 'expense-note-filter-drawer-input--textfield-order-no',
    inputTextfieldShipmentNo: 'expense-note-filter-drawer-input--textfield-shipment-no',
    inputTextfieldCompassNo: 'expense-note-filter-drawer-input--textfield-compass-no',
    statusFieldWrap: 'expense-note-filter-drawer__status-field',
    inputSelectStatus: 'expense-note-filter-drawer-input--select-status',
    actionsRow: 'expense-note-filter-drawer__actions-row',
    inputButtonClear: 'expense-note-filter-drawer-input--button-clear',
    inputButtonApply: 'expense-note-filter-drawer-input--button-filter',
} as const;

export const EXPNOTEGRID = {
    section: 'expense-note-datagrid-section',
    breadcrumbWrap: 'expense-note-datagrid-section__breadcrumb-wrap',
    gridWrap: 'expense-note-datagrid-section__grid-wrap',
    cellWrapOrder: 'expense-note-datagrid-cell-wrap--order',
    cellLinkOrder: 'expense-note-datagrid-cell--link-order',
    cellWrapShipment: 'expense-note-datagrid-cell-wrap--shipment',
    cellLinkShipment: 'expense-note-datagrid-cell--link-shipment',
    cellTextNo: 'expense-note-datagrid-cell--voucher-no',
    cellTextDate: 'expense-note-datagrid-cell--voucher-date',
    cellTextStatus: 'expense-note-datagrid-cell--print-status',
    inputButtonPrintRow: 'expense-note-datagrid-input--button-print-row',
    cellPrintedDate: 'expense-note-datagrid-cell--printed-date',
    previewCellWrap: 'expense-note-datagrid-cell--preview-actions',
    inputButtonPreview: 'expense-note-datagrid-input--button-document-preview',
    pdfDialog: 'expense-note-pdf-preview-dialog',
    pdfDialogTitle: 'expense-note-pdf-preview-dialog__title',
    pdfEmbedWrap: 'expense-note-pdf-preview-dialog__embed-wrap',
    pdfEmbed: 'expense-note-pdf-preview-dialog-input--embed-preview',
} as const;

export const expnoteCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
